/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Bucket Portal
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CheckFileRequestPasswordBody
} from './schemas/check-file-request-password-body';

import type {
  CheckFileRequestPassword200
} from './schemas/check-file-request-password200';

import type {
  CloseFileRequest200
} from './schemas/close-file-request200';

import type {
  CreateFileRequest200
} from './schemas/create-file-request200';

import type {
  CrupdateFileRequestRequest
} from './schemas/crupdate-file-request-request';

import type {
  GetFileRequestPageDataParams
} from './schemas/get-file-request-page-data-params';

import type {
  GetFileRequestPageData200
} from './schemas/get-file-request-page-data200';

import type {
  ListFileRequestsParams
} from './schemas/list-file-requests-params';

import type {
  ListFileRequests200
} from './schemas/list-file-requests200';

import type {
  ReopenFileRequest200
} from './schemas/reopen-file-request200';

import type {
  RetrieveFileRequest200
} from './schemas/retrieve-file-request200';

import type {
  SendFileRequestEmailBody
} from './schemas/send-file-request-email-body';

import type {
  UpdateFileRequest200
} from './schemas/update-file-request200';

import { orvalApiFetch } from '../../../common/foundation/resources/client/http/query-client';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary List file requests
 */
export const listFileRequests = (
    params?: ListFileRequestsParams,
 options?: SecondParameter<typeof orvalApiFetch<ListFileRequests200>>,) => {
      return orvalApiFetch<ListFileRequests200>(
      {url: `/file-requests`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Create a new file request
 */
export const createFileRequest = (
    crupdateFileRequestRequest: CrupdateFileRequestRequest,
 options?: SecondParameter<typeof orvalApiFetch<CreateFileRequest200>>,) => {
      return orvalApiFetch<CreateFileRequest200>(
      {url: `/file-requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: crupdateFileRequestRequest
    },
      options);
    }
  /**
 * @summary Retrieve a file request
 */
export const retrieveFileRequest = (
    id: number,
 options?: SecondParameter<typeof orvalApiFetch<RetrieveFileRequest200>>,) => {
      return orvalApiFetch<RetrieveFileRequest200>(
      {url: `/file-requests/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update a file request
 */
export const updateFileRequest = (
    id: number,
    crupdateFileRequestRequest: CrupdateFileRequestRequest,
 options?: SecondParameter<typeof orvalApiFetch<UpdateFileRequest200>>,) => {
      return orvalApiFetch<UpdateFileRequest200>(
      {url: `/file-requests/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: crupdateFileRequestRequest
    },
      options);
    }
  /**
 * @summary Delete a file request
 */
export const deleteFileRequest = (
    id: number,
 options?: SecondParameter<typeof orvalApiFetch<void>>,) => {
      return orvalApiFetch<void>(
      {url: `/file-requests/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Close a file request
 */
export const closeFileRequest = (
    id: number,
 options?: SecondParameter<typeof orvalApiFetch<CloseFileRequest200>>,) => {
      return orvalApiFetch<CloseFileRequest200>(
      {url: `/file-requests/${id}/close`, method: 'POST'
    },
      options);
    }
  /**
 * @summary Reopen a closed file request
 */
export const reopenFileRequest = (
    id: number,
 options?: SecondParameter<typeof orvalApiFetch<ReopenFileRequest200>>,) => {
      return orvalApiFetch<ReopenFileRequest200>(
      {url: `/file-requests/${id}/reopen`, method: 'POST'
    },
      options);
    }
  /**
 * @summary Send file request link via email
 */
export const sendFileRequestEmail = (
    id: number,
    sendFileRequestEmailBody: SendFileRequestEmailBody,
 options?: SecondParameter<typeof orvalApiFetch<void>>,) => {
      return orvalApiFetch<void>(
      {url: `/file-requests/${id}/send-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendFileRequestEmailBody
    },
      options);
    }
  /**
 * @summary Retrieve or render the public file request page
 */
export const getFileRequestPageData = (
    hash: string,
    params?: GetFileRequestPageDataParams,
 options?: SecondParameter<typeof orvalApiFetch<GetFileRequestPageData200>>,) => {
      return orvalApiFetch<GetFileRequestPageData200>(
      {url: `/file-request-page/${hash}`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Check if the password matches the file request password
 */
export const checkFileRequestPassword = (
    hash: string,
    checkFileRequestPasswordBody: CheckFileRequestPasswordBody,
 options?: SecondParameter<typeof orvalApiFetch<CheckFileRequestPassword200>>,) => {
      return orvalApiFetch<CheckFileRequestPassword200>(
      {url: `/file-request-page/${hash}/check-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkFileRequestPasswordBody
    },
      options);
    }
  export type ListFileRequestsResult = NonNullable<Awaited<ReturnType<typeof listFileRequests>>>
export type CreateFileRequestResult = NonNullable<Awaited<ReturnType<typeof createFileRequest>>>
export type RetrieveFileRequestResult = NonNullable<Awaited<ReturnType<typeof retrieveFileRequest>>>
export type UpdateFileRequestResult = NonNullable<Awaited<ReturnType<typeof updateFileRequest>>>
export type DeleteFileRequestResult = NonNullable<Awaited<ReturnType<typeof deleteFileRequest>>>
export type CloseFileRequestResult = NonNullable<Awaited<ReturnType<typeof closeFileRequest>>>
export type ReopenFileRequestResult = NonNullable<Awaited<ReturnType<typeof reopenFileRequest>>>
export type SendFileRequestEmailResult = NonNullable<Awaited<ReturnType<typeof sendFileRequestEmail>>>
export type GetFileRequestPageDataResult = NonNullable<Awaited<ReturnType<typeof getFileRequestPageData>>>
export type CheckFileRequestPasswordResult = NonNullable<Awaited<ReturnType<typeof checkFileRequestPassword>>>
